import { Directive, Input, HostBinding, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Shell } from './shell';
import { Logger } from './logger';

@Directive({
    selector: '[dialogLink]'
})
export class DialogLinkDirective implements OnInit {
    constructor(
        private router : Router,
        private shell : Shell
    ) {

    }

    @Input()
    dialogLink : string; 

    @HostBinding('attr.href')
    href : string;

    @HostListener('click')
    onClick() {
        let link = this.dialogLink.replace(/^\//g, '');
        let route = this.router.config.find(x => x.path == link);
        if (!route || !route.data || !route.data.dialog)
            return true;

        let dialogName = route.data.dialog;
        if (route.data.loadChildren) {
            dialogName = `${dialogName}@${route.data.loadChildren}`;
        }

        this.shell.showDialog(dialogName);
        return false;
    }

    ngOnInit() {
        this.href = this.dialogLink;
    }
}